import { createSelector } from 'reselect';

import { AppStateType } from 'src/store/appstate.type';
import { ERROR_REDUCER } from './constants';

const selectErrorDomain = (state: AppStateType) => state[ERROR_REDUCER];

export const makeSelectError = () =>
  createSelector(selectErrorDomain, (appState) => (appState ? appState.error : null));
